<template>
    <a href="javascript:0;"
        data-bs-toggle="popover"
        :title="getTitleText"
        data-bs-trigger="hover"
        data-bs-placement="top"
        data-bs-custom-class="cost-help"
        data-bs-html="true"
        v-if="serviceId == 64982 || serviceId == 64987 || serviceId == 65064 || serviceId == 65065"
        :data-bs-content="gethelpText">
        <i class="fa-sharp fa-light fa-circle-info"></i>
    </a>

</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'cost-help',
    	props: {
    		serviceId: Number
    	},
    	mounted: function() {
    		$('[data-bs-toggle="tooltip"]').tooltip();
    		$('[data-bs-toggle="popover"]').popover();
    	},
    	computed: {
    		getTitleText: function() {
    			var titleText = 'Zusätzliche Informationen';

    			return titleText;
    		},
    		gethelpText: function() {
    			var helpText;
    			if (this.serviceId == 64982 || this.serviceId == 64987) {
    				helpText = 'Das zusätzliche Wäscheset besteht aus: 1 Duschtuch, 2 Handtüchern, Bettwäsche, 1 Badvorleger und 1 Geschirrtuch.<br/><strong>Hinweis:</strong> Pro Person ist bereits ein Wäsche-Set inklusive, es handelt sich hier also nur um ein zusätzliches Set.';
    			} else if (this.serviceId == 65064 || this.serviceId == 65065) {
    				helpText = 'Das zusätzliche Handtuch-Set besteht aus: 2 Duschtüchern und 2 Handtüchern.<br/><strong>Hinweis:</strong> Im regulären Wäsche-Set ist bereits 1 Duschtuch und 2 Handtücher enthalten.';
    			}

    			return helpText;
    		}
    	}
    };
</script>